/**
 * Tendances calculées côté client à partir des états reçus : variation de
 * la trésorerie par heure de jeu, pour la barre de ressources.
 */
const samples: [number, number][] = [];

/** Enregistre la trésorerie à l'horloge de jeu `game` (au plus une mesure toutes les 30 s de jeu). */
export function sampleCash(game: number, cash: number): void {
  const last = samples[samples.length - 1];
  if (last && game < last[0]) samples.length = 0;
  if (last && game - last[0] < 30) return;
  samples.push([game, cash]);
  while (samples.length > 2 && game - (samples[0] as [number, number])[0] > 2 * 3600) samples.shift();
}

/** Variation de trésorerie par heure de jeu sur la dernière heure, ou null si trop peu de recul. */
export function cashTrendPerHour(game: number, cash: number): number | null {
  let ref: [number, number] | null = null;
  for (const s of samples) {
    if (game - s[0] <= 3600) {
      ref = s;
      break;
    }
  }
  if (!ref || game - ref[0] < 600) return null;
  return ((cash - ref[1]) * 3600) / (game - ref[0]);
}
